import { Tabs } from '../types';
import { SubscriptionSummary } from '../../../types/subscription';
import { Exchange } from 'grts-utils/types/Exchange';
import ManualDistribution from './ManualDistribution';
import DepositDistribution from './DepositDistribution';

type AvailableBalances = Record<string, Record<string, number>>;

interface Props {
  activeTab: string;
  subscriptions: SubscriptionSummary[];
  exchanges: Exchange[];
  selectedExchange: Exchange | null;
  onExchangeChange: (exchange: Exchange) => void;
  availableBalances: AvailableBalances | undefined;
}

const Content = ({
  activeTab,
  subscriptions,
  exchanges,
  selectedExchange,
  onExchangeChange,
  availableBalances,
}: Props) => {
  switch (activeTab) {
    case Tabs.ManualDistribution:
      return (
        <ManualDistribution
          subscriptions={subscriptions}
          exchanges={exchanges}
          selectedExchange={selectedExchange}
          onExchangeChange={onExchangeChange}
        />
      );
    case Tabs.DepositDistribution:
      return (
        <DepositDistribution
          subscriptions={subscriptions}
          exchanges={exchanges}
          selectedExchange={selectedExchange}
          onExchangeChange={onExchangeChange}
          availableBalances={availableBalances}
        />
      );
    default:
      return null;
  }
};

export default Content;
